import React, {ReactEventHandler, ReactHTMLElement, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {connect, useDispatch} from 'react-redux';
import Flatpickr from 'react-flatpickr';
import {toast} from 'react-toastify';
import moment from 'moment';
// import 'react-select/dist/react-select.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-activity/dist/react-activity.css';
import '../../../node_modules/flatpickr/dist/themes/material_blue.css';
import {getInvoiceQuery, getInvoiceTotal, getSelectedInvoiceKeys} from '../../selectors/Selectors';

import {
    clearSelectedInvoices,
    updateInvoiceSearch,
    updateInvoiceSearchDueToDate,
    updateSelectedCard
} from '../../actions/InvoiceActions';
import {InvoiceList} from './InvoiceList';
import {getPastYears} from '../../common/invoiceHelpers';
import {ThunkFunction} from "../../interfaces/utils";
import {FormattedMessage, useIntl} from "react-intl";
import {CurrencySelector, useHasMultiCurrency} from "./CurrencySelector";
import {useCalendarTranslation} from "../../hooks/CalendarTranslation";
import {SecondarySelect} from "../SecondarySelect";
import {DashboardDetails} from "../dashboard/DashboardPage";
import {useInvoices} from "./InvoiceDataManager";
import {useCanMakePayments} from "../../selectors/ConfigSelectors";
import {DocumentStatus} from "../../interfaces/invoice";
import { CurrencyDisplay } from '../../common/CurrencyDisplay';

interface InvoicePageProps {
    accountType: any;
    invoiceSearchDueDateTo: any;
    invoiceTotal: any;
    secondaryAccounts: any;
    selectedInvoicesKeys: any;
    selectedCurrency: string,
    invoiceSearchQuery: any,
}

interface InvoiceDispatchProps {
    updateSelectedCard: ThunkFunction<typeof updateSelectedCard>,
    clearSelectedInvoices: ThunkFunction<typeof clearSelectedInvoices>,
    updateInvoiceSearchDueToDate: ThunkFunction<typeof updateInvoiceSearchDueToDate>,
    dispatch: any,
}

function _Invoices(props: InvoicePageProps & InvoiceDispatchProps) {
    const intl = useIntl();
    const f = id => intl.formatMessage({id: id});
    const calIl8n = useCalendarTranslation();
    const hasMultiCurrency = useHasMultiCurrency();
    const invoices = useInvoices();
    const dispatch = useDispatch();
    // const [invoices, updateInvoices, clearInvoices] = useContext(InvoicesContext);

    let [selectedDueOption, setSelectedDueOption] = useState<'' | 'all' | 'all-paid' | 'due-up-to'>('all');
    let [selectedYear, setSelectedYear] = useState(moment().year());
    const canMakePayment = useCanMakePayments();
    const [showSummary, setShowSummary] = useState(true);

    useEffect(() => {
        props.updateSelectedCard("");
    }, []);

    useEffect(() => {
        let defaultToDate = moment(new Date()).format('MM-DD-YYYY');
        let status = DocumentStatus.Open;
        if (selectedDueOption === 'due-up-to' || selectedDueOption === '') {
            defaultToDate = moment(new Date()).format('MM-DD-YYYY');
        } else if (selectedDueOption === 'all-paid') {
            status = DocumentStatus.Complete;
        } else if (selectedDueOption === 'all') {
            defaultToDate = '';
            status = DocumentStatus.Open;
        }

        if (selectedDueOption === 'all-paid') {
            dispatch(updateInvoiceSearch({
                status: status,
                due_date_to: '',
                date_from: moment().year(selectedYear).startOf('year').format('MM-DD-YYYY'),
                date_to: moment().year(selectedYear).endOf('year').format('MM-DD-YYYY')
            }));
        } else {
            dispatch(updateInvoiceSearch({
                status: status,
                due_date_to: defaultToDate,
                date_to: '',
                date_from: '',
            }));
        }
    }, [selectedDueOption, selectedYear]);


    let onContinueClick = event => {
        if (props.selectedInvoicesKeys.length === 0) {
            event.preventDefault();
            toast.warn(f("invoices_page.error.no_invoices_selected"), {position: toast.POSITION.TOP_RIGHT});
            return;
        }
        if (props.invoiceTotal <= 0) {
            event.preventDefault();
            toast.warn(
                f("invoices_page.error.credit_amount_validation"),
                {position: toast.POSITION.TOP_RIGHT},
            );
            return;
        }
    };

    function handleSelectedDates(selectedDates) {
        props.clearSelectedInvoices();
        let toDate = '';
        if (selectedDates && selectedDates.length > 0) {
            toDate = moment(selectedDates[0]).format('MM-DD-YYYY');
        } else {
            toDate = moment([new Date().getFullYear(), 11, 31]).format('MM-DD-YYYY');
        }
        props.updateInvoiceSearchDueToDate(toDate);
    }

    let handleDueChange = event => {
        props.clearSelectedInvoices();
        let selectedDueOption = event.target.value;
        setSelectedDueOption(selectedDueOption);


        // props.updateInvoiceSearchDueToDate(defaultToDate);
    };

    const toDate = props.invoiceSearchDueDateTo ? new Date(props.invoiceSearchDueDateTo) : '';


    function handleYearChange(e: React.ChangeEvent<HTMLSelectElement>) {
        setSelectedYear(parseInt(e.target.value));
    }

    return (
        <div className="container" id="invoicePage">
            <div id="divFilterControls" className="row">
                <div className="col-lg-3 col-sm-4 form-group">
                    <SecondarySelect accountType={props.accountType}/>
                </div>
                {hasMultiCurrency && <div className="col-lg-1 col-md-1 col-2 p-0 customSelect">
                  <CurrencySelector/>
                  <i className="fas fa-chevron-down select-arrow"></i>
                </div>}
                <div className=" form-group customSelect"
                     style={{width: "302px", paddingLeft: "14px", paddingRight: "14px"}}>
                    <select className={'form-control invoicesHeadingInput'} onChange={handleDueChange}
                            value={selectedDueOption}>
                        <option value="all">{f("invoices_page.filter.show_all")}</option>
                        <option value="due-up-to">{f("invoices_page.filter.due_till")}</option>
                        <option value="all-paid">{intl.formatMessage({
                            id: "invoices_page.filter.show_paid",
                            defaultMessage: "All Paid"
                        })}</option>
                    </select>
                    <i className="fas fa-chevron-down select-arrow"></i>
                </div>
                {selectedDueOption === 'due-up-to' && (
                    <div className="col-lg-2 col-sm-4 form-group">
                        <div>
                            <i className="calendarPosition fa fa-calendar-alt"/>
                            <Flatpickr
                                className="inp form-control inv-calendar"
                                value={toDate}
                                options={{
                                    formatDate: (date) => {
                                        return intl.formatDate(date)
                                    },
                                    locale: calIl8n,
                                }}
                                onClose={handleSelectedDates}
                                placeholder="Due Til"

                            />
                        </div>
                    </div>
                )}
                {selectedDueOption === 'all-paid' && (
                    <div className={"col-12 col-md"}>
                        <div className={"row align-items-center"}>
                            <div className={"form-group"}>
                                <FormattedMessage id={"invoice_search.period_label"}/>
                            </div>
                            <div className="col form-group customSelect">
                                <select className={'form-control invoicesHeadingInput'} onChange={handleYearChange}
                                        value={selectedYear}>
                                    {getPastYears(5).map(year => {
                                        return <option value={year}>{year}</option>
                                    })}
                                </select>
                                <i className="fas fa-chevron-down select-arrow"></i>
                            </div>
                        </div>
                    </div>
                )}
                <div className="col-12 col-md my-3 my-md-0">
                    <div className={"row flex-fill d-flex justify-content-between justify-content-md-end align-items-center"}>
                        <div>
                            <span className="invoicesHeading"><FormattedMessage id={"invoices_page.continue"}/> </span>
                            <span className={props.invoiceTotal >= 0 ? 'credit-positive' : 'credit-negative'}>
                            &nbsp;&nbsp;<CurrencyDisplay currency={props.selectedCurrency} value={props.invoiceTotal}/>
                        </span>
                        </div>
                        <div className="ml-md-2 ml-0">
                            {canMakePayment &&
                            <Link className="btn btn-primary buttonColor" to="/invoices/pay" onClick={onContinueClick}>
                              <FormattedMessage id={"invoices_page.continue"}/> <i className="fas fa-angle-right"/>
                            </Link>}
                        </div>
                    </div>
                </div>
            </div>
            {showSummary && <DashboardDetails/>}
            <InvoiceList isSearch={false}/>
        </div>
    );

}

export default connect<InvoicePageProps, any, any, any>((store: any, props) => ({
    accountType: store.user_options.accountType,
    invoiceSearchDueDateTo: store.user_options.invoiceSearchDueDateTo,
    invoiceSearchQuery: getInvoiceQuery(store),
    selectedCurrency: store.default.selectedCurrencyOptionValue,
    invoiceTotal: getInvoiceTotal(store),
    secondaryAccounts: store.user_options.secondaryAccounts,
    selectedInvoicesKeys: getSelectedInvoiceKeys(store)
}), {
    updateSelectedCard,
    clearSelectedInvoices,
    updateInvoiceSearchDueToDate,
})(_Invoices);
